var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import Cleave from 'cleave.js/react';
import React, { Component } from 'react';
import { AutoCompleteTypes } from '../MaskedTextField';
import { AutosaveField } from './AutosaveField';
import styles from './AutosaveInput.module.css';
var AutosaveInput = /** @class */ (function (_super) {
    __extends(AutosaveInput, _super);
    function AutosaveInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function (event) {
            if (_this.props.readOnly)
                return;
            if (_this.props.disabled)
                return;
            if (_this.props.onClick)
                _this.props.onClick(event);
        };
        _this.handleBlur = function (event) {
            if (_this.props.readOnly)
                return;
            if (_this.props.disabled)
                return;
            if (_this.props.onBlur)
                _this.props.onBlur(event);
        };
        _this.handleFocus = function (event) {
            if (_this.props.readOnly)
                return;
            if (_this.props.disabled)
                return;
            if (_this.props.onFocus)
                _this.props.onFocus(event);
        };
        _this.handleMouseDown = function (event) {
            if (_this.props.readOnly)
                return;
            if (_this.props.disabled)
                return;
            if (_this.props.onMouseDown)
                _this.props.onMouseDown(event);
        };
        _this.renderTextField = function (fieldProps) {
            var errorText = fieldProps.error && fieldProps.touched ? fieldProps.error : '';
            var onChange = function (event) {
                if (_this.props.readOnly)
                    return;
                if (_this.props.disabled)
                    return;
                fieldProps.onChange(event.target.value);
                if (_this.props.onChange)
                    _this.props.onChange(event);
            };
            var autoCompleteValue = _this.props.autoCompleteType === AutoCompleteTypes.UserInfo ? 'off-no-complete' : 'off';
            return (React.createElement("div", { className: classNames(styles.container, _this.props.containerClass) },
                _this.props.formatOptions ? (React.createElement(Cleave, { htmlRef: function (e) {
                        // This is to map between useRef and normal functional refs. There may be a more elegant way to tackle this.
                        if (_this.props.inputRef)
                            _this.props.inputRef.current = e;
                    }, options: _this.props.formatOptions, value: fieldProps.fieldValue || '', name: fieldProps.field.toString(), onChange: onChange, onClick: _this.handleOnClick, autoComplete: autoCompleteValue, onBlur: _this.handleBlur, onMouseDown: _this.handleMouseDown, onFocus: _this.handleFocus, disabled: _this.props.disabled, style: _this.props.style, placeholder: _this.props.placeholder, readOnly: _this.props.readOnly, maxLength: _this.props.maxLength, className: _this.props.className, autoFocus: _this.props.autoFocus, "data-test-id": fieldProps.field.toString() })) : (React.createElement("input", { ref: _this.props.inputRef, autoFocus: _this.props.autoFocus, value: fieldProps.fieldValue || '', name: fieldProps.field.toString(), onChange: onChange, onClick: _this.props.onClick, onBlur: _this.props.onBlur, onMouseDown: _this.props.onMouseDown, onFocus: _this.props.onFocus, disabled: _this.props.disabled, style: _this.props.style, placeholder: _this.props.placeholder, readOnly: _this.props.readOnly, maxLength: _this.props.maxLength, className: _this.props.className, "data-test-id": fieldProps.field.toString(), autoComplete: autoCompleteValue })),
                (!_this.props.hideWarningEmptyHelperText || errorText) && (React.createElement(FormHelperText, { classes: { root: styles.error } }, errorText || ' '))));
        };
        return _this;
    }
    AutosaveInput.prototype.render = function () {
        return React.createElement(AutosaveField, { field: this.props.field, render: this.renderTextField });
    };
    return AutosaveInput;
}(Component));
export { AutosaveInput };
